import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import LegoAdminPageContext from '../../pages/legoAdminPageContext'; // Adjusted path
import { UserAvatarLive } from '../common/UserAvatarLive';
import { LoadingSpinner } from '../common/LoadingSpinner';

export default function LiveScriptSummaryBar({ name: scriptNameFilter }) {
    const { page } = useContext(LegoAdminPageContext);

    const scripts = page.service('services/scripts/runs');

    const [runs, setRuns] = useState([]);

    const fetchScripts = async () => {
        try {
            // Fetch all scripts, filtering will be done on the client
            const { runningScripts } = await scripts.find({query: {onlyRunning: true, onlyName: scriptNameFilter}});
            setRuns(runningScripts);
        } catch (error) {
            alert(error);
            console.error("Error fetching scripts:", error);
        }
    };

    const onRunUpdate = (update) => {      
        console.log('onRunUpdate', update);
        if (update && update._id && update.state === 'running') {
            // If a name filter is active, only proceed if the update matches the name
            if (scriptNameFilter && update.name !== scriptNameFilter) {
                return;
            }

            const { _id, progressText, progressData } = update;
            setRuns(prevRuns => {
                const runIndex = _.findIndex(prevRuns, { _id });

                if (runIndex !== -1) {
                    // Update existing run
                    const newRuns = [...prevRuns];
                    newRuns[runIndex] = { ...newRuns[runIndex], progressText, progressData };
                    return newRuns;
                } else {                    
                    return [ ... prevRuns, update]; // Return previous runs until fetch completes
                }
            });
            return;
        } else {
          // If update is not specific (e.g. a generic removal event), or any other case, refetch to be safe.
          fetchScripts().catch(alert);
        }
    };

    useEffect(() => {
        fetchScripts().catch(alert);

        const handleProgress = (update) => onRunUpdate(update);
        const handleOther = (data) => {
            fetchScripts().catch(alert);
            console.log('handleOther', data);
        };

        scripts.on('updated', handleOther);
        scripts.on('created', handleOther);
        scripts.on('removed', handleOther);
        scripts.on('scriptProgress', handleProgress);

        return () => {
            scripts.removeListener('updated', handleOther);
            scripts.removeListener('created', handleOther);
            scripts.removeListener('removed', handleOther);
            scripts.removeListener('scriptProgress', handleProgress);
        };
    }, [scripts, scriptNameFilter]); // Add scriptNameFilter to dependencies

    return (
        <div>
            <div>
                <span>{runs.map(r => <span key={r._id} className={'badge badge-secondary'}>
                  <LoadingSpinner/>
                  <span style={{width: '28px', display: 'inline-block'}}></span>
                  {r.script} - {r.progressData?.count ?? '?'}/{r.progressData?.total ?? '?'} <UserAvatarLive user={r.createdBy}/>
                   <span className='ml-1 mr-1 font-italic inline-block small text-ellipsis' style={{maxWidth: '150px'}}>{r.progressText}</span>
                   </span>)}</span>
            </div>
        </div>
    );
}